var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import HeaderItem from "../accountcheck/components/HeaderItem.vue";
import PaymentService from '../../api/UpperPaymentService';
import { Loading } from 'element-ui';
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
import { toDetail } from '../../helper/util';
import { EBillType } from '../../enum/EBillType';
import ImageView from "../payment/component/ImageView.vue";
var PaymentOrderDetail = (function (_super) {
    __extends(PaymentOrderDetail, _super);
    function PaymentOrderDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = [];
        _this.total = 0;
        _this.tableHeight = 350;
        _this.rowId = null;
        _this.order = {};
        _this.imageOpen = false;
        _this.imageArr = [];
        _this.title = '付款凭证';
        return _this;
    }
    PaymentOrderDetail.prototype.created = function () {
        this.service = PaymentService.getInstance();
        this.getPaymentDetail();
    };
    PaymentOrderDetail.prototype.getPaymentDetail = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.detail(Object.assign({ order_id: this.rowId }, pager)).then(function (res) {
            if (res.data.success) {
                var data = res.data.data;
                _this.data = data.detail.data;
                _this.total = data.detail.total;
                _this.order = data;
                _this.imageArr = data.payment_voucher;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    PaymentOrderDetail.prototype.pageChange = function (pager) {
        this.getPaymentDetail(pager);
    };
    PaymentOrderDetail.prototype.toStatementOrderDetail = function (row) {
        toDetail(EBillType.UpperSupCheck, row.order_id, this);
    };
    PaymentOrderDetail.prototype.auditOne = function (order_id) {
        var _this = this;
        this.$confirm('审核后将不可修改，是否继续？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            _this.audit({ order_ids: order_id });
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PaymentOrderDetail.prototype.audit = function (params) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.audit(params).then(function (res) {
            loadingInstance.close();
            if (res.data.code == 76) {
                _this.$message.error(res.data.msg);
            }
            else {
                _this.$message.success(res.data.msg);
            }
            _this.getPaymentDetail();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PaymentOrderDetail.prototype.deleteOne = function (order_id) {
        var _this = this;
        this.$confirm('确认要废弃这个订单吗？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            _this.delete({ order_ids: order_id });
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PaymentOrderDetail.prototype.delete = function (params) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.delete(params).then(function (res) {
            loadingInstance.close();
            if (res.data.code == 76) {
                _this.$message.error(res.data.msg);
            }
            else {
                _this.$message.success(res.data.msg);
            }
            _this.getPaymentDetail();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PaymentOrderDetail.prototype.watch_vorcher = function () {
        this.imageOpen = true;
    };
    PaymentOrderDetail.prototype.closeimg = function (type) {
        this.imageOpen = type;
    };
    PaymentOrderDetail = __decorate([
        auth(nameDict["供应商付款单"]),
        Component({
            components: {
                HeaderItem: HeaderItem,
                'image-view': ImageView,
            }
        })
    ], PaymentOrderDetail);
    return PaymentOrderDetail;
}(Vue));
export default PaymentOrderDetail;
